<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="gujia_wbox">

				<ul class="gamelist_ul gamelist_ul2">

					<li :class="{'active':gameindex == index}" v-for="(item, index)  in gamelist"
						@click="chose(item.id,index)">
						<div class="image">

							<el-image :src="'http://img.h6ds.com'+item.image3" lazy></el-image>
						</div>
						<p>{{item.name}}</p>
					</li>

				</ul>

				<div class="wbox" v-for="(item, index)  in field">


					<div class="g_ti">
						<div class="lable">
							{{item.title}} <span v-if="item.require == true">*</span>
						</div>
						<div v-if="item.type =='radio'">
							<el-radio-group v-model="item.name">
								<el-radio-button v-for="(item1, index1) in item.dataSource" :label="item1.key">{{
				                                    item1.text }}</el-radio-button>
							</el-radio-group>
						</div>
						<div v-if="item.type =='checkbox'">
							<el-checkbox-group v-model="item.name">
								<el-checkbox-button v-for="(item1, index1) in item.dataSource" :label="item1.key">{{
					                                    item1.text }}</el-checkbox-button>
							</el-checkbox-group>
						</div>
						<div v-if="item.type =='region'">
							<el-select v-model="item.value1" placeholder="请选择" @change="daqu(index)">
								<el-option v-for="(item1, index1) in item.dataSource.regionLevelBigs"
									:label="item1.name" :key="item1.id" :value="item1.id">
								</el-option>
							</el-select>
							<el-select v-model="item.value2" placeholder="请选择">
								<el-option v-for="(item1, index1) in item.dataSource.regionLevelSmalls"
									:label="item1.name" :key="item1.id" :value="item1.id"
									v-if="item1.firstID == item.value1">
								</el-option>
							</el-select>
						</div>
						<div v-if="item.type =='numtext'" class="gh_row2">
							<span>{{ item.text }}</span>
							<el-input type="number" v-model="item.name" placeholder="请输入内容"></el-input>
						</div>
						<div v-if="item.type =='text'" class="gh_row2">
							<span>{{ item.text }}</span>
							<el-input v-model="item.name" placeholder="请输入内容"></el-input>
						</div>
						<div v-if="item.type =='textarea'" class="gh_row">
							<el-input type="textarea" v-model="item.name" placeholder="请输入内容"></el-input>
						</div>


					</div>
				</div>

				<div class="guhao_text">
					<div class="miaoshu">
						<h2>提示：【请把复制的帐号属性，发送收号客服评估】</h2>
						<h4 v-if="show_text == true">您还没有生成评估信息</h4>
					</div>
					<div class="con" id="con">
						<p v-for="(item, index) in text">{{ item.title }}:{{ item.val }}</p>
					</div>
					<div class="gujia_buttonbox">
						<button class="debutton" @click="tijiao">生成评估</button>
						<button class="debutton" @click="fuzhi">复制</button>
					</div>


				</div>
			</div>
		</div>
	</div>

</template>


<script>
	export default {
		data() {
			return {
				field: [],
				num: 0,
				model: [],
				gameid: 5,
				text: [],
				gamelist: [{
					"id": 5,
					"type": "list",
					"model_id": 4,
					"parent_id": 19,
					"name": "\u5730\u4e0b\u57ce\u4e0e\u52c7\u58eb",
					"image": "\/uploads\/20210126\/FmSPTg2hHPClXmpdvoUrZDCGSbW2.png",
					"image2": "\/uploads\/20210304\/Ft5R-jWtzPe-DsFpM24-7taKvRKm.png",
					"image3": "\/uploads\/20210324\/Fk-Qfuv-N-J6OWIAaQ7IN78v0kpM.jpg",
					"flag": "",
					"seotitle": "",
					"keywords": "",
					"description": "",
					"diyname": "maihao",
					"outlink": "",
					"items": 291,
					"weigh": 2,
					"channeltpl": "",
					"listtpl": "list_dnf.html",
					"showtpl": "show_dnf.html",
					"pagesize": 12,
					"iscontribute": 1,
					"isnav": 1,
					"createtime": 1587109085,
					"updatetime": 1616597144,
					"status": "normal"
				}, {
					"id": 17,
					"type": "list",
					"model_id": 7,
					"parent_id": 19,
					"name": "QQ\u98de\u8f66",
					"image": "\/uploads\/20210205\/FmU9tVw-p1qFaBl3UZ3SrwlZ5646.jpg",
					"image2": "\/uploads\/20210304\/FoBBhQXmvw1dNUo0QrdSdDDUACds.png",
					"image3": "\/uploads\/20210324\/FuI8jHE1M7rt41Dnp4CO64cZFbxX.jpg",
					"flag": "",
					"seotitle": "",
					"keywords": "",
					"description": "",
					"diyname": "feiche",
					"outlink": "",
					"items": 1645,
					"weigh": 1,
					"channeltpl": "",
					"listtpl": "list_qqfeiche.html",
					"showtpl": "show_qqfeiche.html",
					"pagesize": 12,
					"iscontribute": 1,
					"isnav": 1,
					"createtime": 1600863346,
					"updatetime": 1629005919,
					"status": "normal"
				}, {
					"id": 35,
					"type": "list",
					"model_id": 12,
					"parent_id": 19,
					"name": "\u82f1\u96c4\u8054\u76df",
					"image": "\/uploads\/20210205\/FgPPrpUov2qGDe0hzUBlXhpAPao4.jpg",
					"image2": "\/uploads\/20210304\/Fk9QWnM5z-EWlA3YWr6Ifq7m0Tsb.png",
					"image3": "\/uploads\/20210324\/FpWIWioi64RD3jb3kts7vdAg4Imr.jpg",
					"flag": "",
					"seotitle": "",
					"keywords": "",
					"description": "",
					"diyname": "lol",
					"outlink": "",
					"items": 237,
					"weigh": 35,
					"channeltpl": "",
					"listtpl": "list_lol.html",
					"showtpl": "show_lol.html",
					"pagesize": 10,
					"iscontribute": 0,
					"isnav": 1,
					"createtime": 1611753322,
					"updatetime": 1616596500,
					"status": "normal"
				}, {
					"id": 36,
					"type": "list",
					"model_id": 10,
					"parent_id": 19,
					"name": "\u7a7f\u8d8a\u706b\u7ebf",
					"image": "\/uploads\/20210205\/FqxCgvmmsW3KeZduO-lqjwQOH7bR.jpg",
					"image2": "\/uploads\/20210304\/FjRP_OyaGRHGXce4MZPQ92XbMsg1.png",
					"image3": "\/uploads\/20210324\/FgDvUp5XrhZ4nj2rtc2DlueuZ_IY.jpg",
					"flag": "",
					"seotitle": "",
					"keywords": "",
					"description": "",
					"diyname": "cf",
					"outlink": "",
					"items": 380,
					"weigh": 36,
					"channeltpl": "",
					"listtpl": "list_cf.html",
					"showtpl": "show_cf.html",
					"pagesize": 10,
					"iscontribute": 0,
					"isnav": 1,
					"createtime": 1611753347,
					"updatetime": 1616597151,
					"status": "normal"
				}, {
					"id": 37,
					"type": "list",
					"model_id": 11,
					"parent_id": 19,
					"name": "\u738b\u8005\u8363\u8000",
					"image": "\/uploads\/20210127\/Fqe-kTugAITyG5NdGCjF7pixBLFo.jpeg",
					"image2": "\/uploads\/20210304\/FqGp9UHWLyNnlPcILNi8-NRnYg2K.png",
					"image3": "\/uploads\/20210324\/FjZPb7pUNVBwNOsx7GSYJSbOoo4A.jpg",
					"flag": "",
					"seotitle": "",
					"keywords": "",
					"description": "",
					"diyname": "wz",
					"outlink": "",
					"items": 50,
					"weigh": 37,
					"channeltpl": "",
					"listtpl": "list_wz.html",
					"showtpl": "show_wz.html",
					"pagesize": 10,
					"iscontribute": 0,
					"isnav": 1,
					"createtime": 1611753374,
					"updatetime": 1616597134,
					"status": "normal"
				}],
				show_text: true,
				gamename: '',
				gameindex: 0,

			}
		},
		created: function(data) {

			this.Filed(this.$data.gameid);

		},
		watch: {
			$route() {

			}
		},
		methods: {
			Filed: function(a) {
				var that = this;


				this.rq.requests.post("api/gujia/field", {
					gameid: a,
				}).then(res => {
					that.$data.field = res.data;

				}).catch(error => {
					
				})

			},

			daqu: function(i) {
				
				this.field[i].value2 = '';


			},
			tijiao: function() {
				this.text = [];
				var data = this.$data.field;
				var text = [];


				text[0] = [];
				text[0].title = '游戏种类';
				text[0].val = this.$data.gamelist[this.$data.gameindex].name;

				var b = 1;
				for (var i = 0; i < data.length; i++) {
					var value = data[i];
					if (value.type == 'radio') {


						if (value.require == true && value.name == 0) {

							this.$message({
								message: '请选择' + value.title,
								type: 'error'
							});
							return;

						}

						if (value.name != 0) {
							for (var i2 = 0; i2 < value.dataSource.length; i2++) {
								var ret = value.dataSource[i2];
								if (ret.key == value.name) {
									text[b] = [];
									text[b].title = value.title;
									text[b].val = ret.text;
								}
							}
							b++;
						}
					}
					if (value.type == 'checkbox') {


						if (value.require == true && value.length <= 0) {

							this.$message({
								message: '请选择' + value.title,
								type: 'error'
							});
							return;

						}


						if (value.name.length > 0) {
							text[b] = [];
							text[b].title = value.title;
							text[b].val = '';
							for (var i2 = 0; i2 < value.dataSource.length; i2++) {
								var ret = value.dataSource[i2];
								if (in_array(ret.key, value.name)) {
									text[b].val = text[b].val + ret.text + "、";
								}
							}
							b++;
						}
					}

					if (value.type == 'textarea') {


						if (value.require == true && value.name == "") {

							this.$message({
								message: '请输入' + value.title,
								type: 'error'
							});
							return;

						}

						if (value.name != "") {
							text[b] = [];
							text[b].title = value.title;
							text[b].val = value.name;
							b++;
						}
					}


					if (value.type == 'numtext') {


						if (value.require == true && value.name == 0) {

							this.$message({
								message: '请输入' + value.title,
								type: 'error'
							});
							return;

						}

						if (value.name != 0) {
							text[b] = [];
							text[b].title = value.title;
							text[b].val = value.name;
							b++;
						}
					}

					if (value.type == 'checkboxNumberPlusMinus') {
						var text_str = "";
						for (var i2 = 0; i2 < value.dataSource.length; i2++) {
							var ret = value.dataSource[i2];

							if (value.name[i2] != 0) {
								text_str = text_str + ret.text + "数量:" + value.name[i2] + '、';
							}
						}
						if (text_str != "") {
							text[b] = [];
							text[b].title = value.title;
							text[b].val = text_str;
							b++;
						}
					}
					if (value.type == 'region') {


						if (value.require == true) {

							if (value.value1 == "") {
								this.$message({
									message: '选择' + value.title,
									type: 'error'
								});
								return;
							}

							if (value.value2 == "") {
								this.$message({
									message: '选择' + value.title,
									type: 'error'
								});
								return;
							}
						}


						if (value.value1 != "" && value.value2 != "") {
							text[b] = [];
							text[b].title = value.title;
							text[b].val = "";
							for (var i2 = 0; i2 < value.dataSource.regionLevelBigs.length; i2++) {
								var ret = value.dataSource.regionLevelBigs[i2];
								if (ret.id == value.value1) {
									text[b].val = text[b].val + ret.name;
								}
							}
							for (var i2 = 0; i2 < value.dataSource.regionLevelSmalls.length; i2++) {
								var ret = value.dataSource.regionLevelSmalls[i2];
								if (ret.id == value.value2) {
									text[b].val = text[b].val + "/" + ret.name;
								}
							}
							b++;
						}
					}

				}
				this.$data.show_text = false;
				this.$data.text = text;


			},
			chose: function(gameid, index) {

				this.$data.gameid = gameid;
				this.Filed(gameid);
				this.$data.gameindex = index

			},
			fuzhi: function() {



				if (this.text.length <= 0) {
					this.$message({
						message: '复制识别内容为空',
						type: 'error'
					});
				}

				var content = "";

				for (var i = 0; i < this.$data.text.length; i++) {
					content = content + this.$data.text[i].title + ":" + this.$data.text[i].val + " \n";
				}

				
				const textarea = document.createElement('textarea');
				textarea.value = content;
				document.body.appendChild(textarea);

				textarea.select();
				if (document.execCommand('copy')) {
					document.execCommand('copy');


					this.$message({
						showClose: true,
						message: '复制成功请联系客服',
						type: 'success'
					});
				}

				document.body.removeChild(textarea);

			}

		}
	}
</script>
